// libraries
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import classNames from "classnames/bind";

// component
import Item from "./Item";

// mockup
import mockup from "src/utils/data";

// assets
import CheckCircle from "src/assets/icons/Check-Circle.svg";
import Placeholder from "src/assets/images/home/gradient.png";

// styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const ShowTime = ({ data }) => {
  const [list, setList] = useState(mockup.empty_3);
  const [showMore, setShowMore] = useState(false);
  const [isFollow, setIsFollow] = useState(false);

  useEffect(() => {
    if (data) setList(data.Slots);
  }, [data]);

  const toggle = () => setShowMore(!showMore);
  const toggleFollow = () => setIsFollow(!isFollow);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={cx("tickets-root")}
    >
      <div className={cx("head")}>
        <div className={cx("venue-content")}>
          {/* <img src={Placeholder} alt="venue" className={cx("venue-img")} /> */}
          <div className={cx("venue-img")} />
          <div>
            <p className={cx("venue-title")}>
              {data?.locationDetail?.venue || data?.locationDetail?.city}
            </p>
            {data && (
              <p className={cx("venue-follow", { following: isFollow })}>
                {!isFollow
                  ? "22 people are following"
                  : "you and 22 others are following"}
              </p>
            )}
          </div>
        </div>
        <button className={cx("btn-follow")} onClick={toggleFollow}>
          {!isFollow ? "Follow" : "Following"}
        </button>
      </div>
      <div className={cx("ticket-wrapper")}>
        {list && (
          <>
            {(list.length > 2 && !showMore
              ? list.slice(0, list.length)
              : list
            )?.map((item, index) => (
              <Item key={index} item={item} />
            ))}
            {list.length > 2 && (
              <span className={cx("more")} onClick={toggle}>
                {!showMore ? "show more" : "show less"}
              </span>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
};

export default ShowTime;
